<template>
	<div id="showItem" v-on:click="onShowClicked">
		<div class="itemContainer">
			<div class="iconContainer">
				<!--<div v-if="!isEditable" class="deleteBtnWrapper" v-on:click.stop.prevent="showDeleteDialog = true">-->
					<div class="deleteBtnWrapper" :class="{deleteBtnWrapperHidden: !isEditable}" v-on:click.stop.prevent="showDeleteDialog = true">
					<svg class="deleteBtn">
						<line x1="0" y1="10" x2="20" y2="30" stroke-width="2" />
						<line x1="0" y1="30" x2="20" y2="10" stroke-width="2" />
					</svg>
					<span class="tooltip">Show löschen</span>
				</div>
				
				<svg class="pages">
					<rect class="page" x="50" y="10" stroke-width="2"/>
					<rect class="page" x="35" y="25" stroke-width="2"/>
					<rect class="page" x="10" y="40" stroke-width="2"/>
				</svg>
			</div>
			<div class="title">{{show.title}}</div>
			<p class="meta">{{getCreationDate}}</p>
			<p v-show="wasUpdated" class="meta">{{getUpdateDate}}</p>
		</div>
		<div class="deleteDialog" v-show="showDeleteDialog">
			<div class="deleteText">Sind Sie sicher, dass Sie die Show löschen wollen?</div>
			<div class="buttonGroup">
				<button class="button" v-on:click.stop.prevent="deleteShow">Ja</button>
				<button class="button" v-on:click.stop.prevent="showDeleteDialog = false">Nein</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {EventBus} from '@/services/EventBus.js';
	import Show from '@/services/Show';

	export default {
		name: "ShowItem",
		props: ["show", "isEditable"],
		data() {
			return {
				showDeleteDialog: false
			}
		},
		methods: {
			onShowClicked() {
				if(!this.isEditable) {
					EventBus.$emit('onPreviewShow', this.show.id);
				} else if(!this.showDeleteDialog) {
					this.$router.push({path: '/showedit/' + this.show.id});
				}
			},
			async deleteShow() {
				console.log("delete this show: " + this.show.title);
				this.showDeleteDialog = false;
				await Show.delete(this.show);
				this.$emit('deleteshow', this.show.id);
			}
		},
		computed: {
			getCreationDate() {
				var date = new Date(this.show.created_at);
				return 'Erstellt: ' + date.getDate() + '.' + (date.getMonth()+1) + '.' + date.getFullYear();
			},
			getUpdateDate() {
				var date = new Date(this.show.updated_at);
				return 'Geändert: ' + date.getDate() + '.' + (date.getMonth()+1) + '.' + date.getFullYear();
			},
			wasUpdated() {
				return this.show.updated_at != this.show.created_at;
			}
		}
	}
</script>

<style scoped>
	#showItem {
		font-family: "BrownLLWeb-Regular";
		width: 250px;
		height: 250px;
		border: solid 2px black;
		background-color: white;
		color: black;
		margin-right: 25px;
		margin-bottom: 25px;
		position: relative;
	}

	#showItem:hover {
		cursor: pointer;
		background-color: black;
		color: white;
	}

	.itemContainer {
		padding-left: 10px;
	}

	.title {
		font-size: 20px; /*25px;*/
		margin-top: 7px; /*2px;*/
		margin-bottom: 6px;
	}

	.meta {
		font-size: 12px;
	}
	
	.iconContainer {
		display: flex;
  		flex-wrap: nowrap;
		margin-top: 5px;
		justify-content: flex-end;
	}

	.deleteBtn {
		stroke: black;
		width: 20px;
		height: 30px;
	}
	#showItem:hover .deleteBtn {
		stroke: white;
	}
	
	.deleteBtnWrapper {
		width: 200px;
		height: 30px;
	}

	.deleteBtnWrapperHidden {
		width: 200px;
		height: 30px;
		visibility: hidden;
	}

	.deleteBtnWrapper .tooltip {
		visibility: hidden;
		padding: 10px 5px;
		color: #fff;
		text-align: left;
		position: absolute;
		z-index: 1;
	}

	.deleteBtnWrapper:hover .tooltip {
		visibility: visible;
	}

	.pages {
		align-self: flex-end;
	}
	
	.page {
		width: 75px;
		height: 100px;
		fill: white;
  		stroke: black;
	}

</style>